import Vue from 'vue';
import VueGtag from 'vue-gtag';
import router from '../../router';

if (process.env.VUE_APP_TRACKING_MODE === 'on') {
    console.log('ga init');

    Vue.use(
        VueGtag,
        {
            config: {
                id: 'UA-121121420-1',
                params: { send_page_view: false },
            },
            includes: [{ id: 'UA-121121420-3' }, { id: 'UA-121121420-6' }],
        },
        router
    );
} else {
    Vue.use({
        install(Vue) {
            Vue.prototype.$gtag = {
                event(action, { ...args }) {
                    console.log('ga event', action, args);
                },
                config(...args) {
                    console.log('ga config', args);
                },
                linker(...args) {
                    console.log('ga linker', args);
                },
            };
        },
    });
}
